<quill-editor class="content-editor" [placeholder]="''" [modules]="quillConfiguration"
	[styles]="{'min-height': '500px'}" [formControl]="control">

</quill-editor>